<template>
    <div class="upload-wrapper mt-10 mb-15">
      <div class="avatar-section ">
        <el-avatar
        class="d-flex flex-justify-center flex-align-items-center avatar"
        icon="el-icon-picture"
        :src="(imgUrl) ? `${imgUrl}?v=${moment().valueOf()}` : ''"
        :key="key"
        :size="120"></el-avatar>
      </div>
      <div class="d-flex justify-content-center w-100">
        <vue-upload-component
        ref="upload"
        :drop=true
        v-model="files"
        :extensions="extensions"
        :accept="accept"
        :post-action="uploadURL"
        :headers="uploadHeaders"
        :multiple=true
        @input-file="inputFile"
        @input-filter="inputFilter"
        class="el-button el-button--primary upload-button">
        Upload
        </vue-upload-component>
        <el-button size="mini" icon="el-icon-delete" class="delete-button" @click="removeImage" v-if="imgUrl !== ''"></el-button>
      </div>
    </div>
  </template>

<script>
import { errormsg } from '@/utils/constants';

export default {
  name: 'UploadItem',
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    type: String,
    label: String
  },
  data() {
    return {
      uploadURL: `${process.env.VUE_APP_API_URL}/assemble/api/v1/portal/files/logo/presigned-url`,
      files: [],
      key: 0,
      accept: 'image/png,image/jpg,image/jpeg,image/heic',
      extensions: 'jpg,jpeg,png',
      imgUrl: ''

    };
  },
  computed: {
    uploadHeaders() {
      return this.$store.getters['user/uploadHeaders'];
    },
  },
  methods: {
    async inputFile(newFile, oldFile) {
      if (newFile && oldFile && !newFile.active && oldFile.active) {
        if (newFile.response.status === 'success') {
          const {
            url, s3Path, name, originalname
          } = newFile.response.data;
          await fetch(url, {
            method: 'PUT',
            body: this.files[0].file,
            headers: { 'Content-Type': '*/*' },
          });
          this.imgUrl = `${s3Path}?v=${this.moment().valueOf()}`;
          this.value = {
            name,
            originalname,
          };
          this.$message.success('Successful');
          this.$emit('input', this.value);
          this.$store.commit('loading', false);
          this.key++;
        } else {
          this.$store.commit('loading', false);
          this.$message.error('Error uploading file');
        }
      }
    },
    inputFilter(newFile, oldFile, prevent) {
      if (!/\.(png|jpg|jpeg)$/i.test(newFile.name)) {
        this.$message.error(errormsg.image_format);
        return prevent();
      }
      // 5mb limit
      if (newFile.size > 1024 * 1024 * 5) {
        this.$message.error(errormsg.file_size);
        return prevent();
      }
      this.$refs.upload.active = true;
      this.$store.commit('loading', { loading: true, text: 'Loading...' });
      return true;
    },
    removeImage() {
      this.$confirm('Are you sure you want to remove this image?', 'Warning')
        .then(() => {
          this.imgUrl = '';
          this.$message.error('Image removed successfully');
        })
        .catch(() => {});
    }
  }
};
</script>

  <style lang="scss" scoped>
  .upload-wrapper {
    display: flex;
    gap: 1rem;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

   .avatar-section {
      overflow: hidden;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      // margin-bottom: 1.5rem;
      .avatar {
      //   background-color: transparent !important;
        font-size: 5.5rem;
        display: flex;
        justify-content: center;
        align-items: center;
        color: $primary !important;
      }
    }

    .upload-button {
      display: flex;
      justify-content: center;
      width: 7.5rem;
    }

    // .delete-button {
    //   width: 7.5rem;
    // }

  ::v-deep .copy .el-input-group__append {
    background-color: $highlight !important;
    border-color: $highlight !important;
    color: white;
  }
  </style>
